var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"inspectionRegisterModal","title":"REJESTR PRZEGLĄDÓW","buttons":[],"register":_vm.register}},[_c('InspectionsTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a06696a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/hydrants/modals/inspections/InspectionsRegister.vue
// module id = 1799
// module chunks = 0